module.exports = __webpack_public_path__ + "img/shanghai_tower.db22aa40.png";